import React from "react";
import Tag from "../Tag";

const experiences = [
  {
    dateFrom: "Nov 2022",
    dateTo: "Oct 2025",
    duration: "3 yrs",
    company: "NTT DATA Business Solutions",
    role: "Software Developer",
    description:
      "Contributed to React Native mobile and React web projects, building end-to-end features for international B2B and B2C clients. On several projects, took ownership of the design process directly in Figma, from initial wireframes through to final implementation.",
    tags: [
      { label: "React", variant: "navy" as const },
      { label: "React Native", variant: "navy" as const },
      { label: "TypeScript", variant: "coral" as const },
      { label: "Figma", variant: "sage" as const },
      { label: "Expo", variant: "outline" as const },
    ],
  },
  {
    dateFrom: "Jun 2022",
    dateTo: "Sep 2022",
    duration: "5 mos",
    company: "Ministry of CRM",
    role: "Junior Frontend Developer",
    description:
      "Built 50+ responsive HTML/CSS email templates within Salesforce Marketing Cloud. Managed content integrations across WordPress and Shopify as part of client-facing delivery work.",
    tags: [
      { label: "HTML", variant: "outline" as const },
      { label: "CSS", variant: "outline" as const },
      { label: "JavaScript", variant: "outline" as const },
      { label: "Salesforce Marketing Cloud", variant: "outline" as const },
    ],
  },
];

function Experience() {
  return (
    <div className="py-14 border-b border-light-gray">
      <div className="flex items-center gap-3 mb-8">
        <span className="text-[11px] tracking-[0.12em] uppercase text-warm-gray font-semibold">
          Experience
        </span>
        <div className="flex-1 h-px bg-light-gray" />
      </div>

      <div className="flex flex-col gap-9">
        {experiences.map((exp) => (
          <div
            key={exp.company}
            className="grid gap-6"
            style={{ gridTemplateColumns: "140px 1fr" }}
          >
            <div className="font-mono text-[11px] text-warm-gray leading-relaxed pt-1">
              {exp.dateFrom}-{exp.dateTo} <br />
              {exp.duration}
            </div>
            <div>
              <h2 className="font-display font-bold text-navy text-base mb-0.5">
                {exp.company}
              </h2>
              <p className="text-[13px] text-coral font-medium mb-2">
                {exp.role}
              </p>
              <p className="text-[14px] text-text-muted leading-[1.65] mb-3">
                {exp.description}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {exp.tags.map((tag) => (
                  <Tag
                    key={tag.label}
                    label={tag.label}
                    variant={tag.variant}
                    small
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Experience;
